import { createContext, useContext } from 'react';
import type { SupportWidgetConfig } from './types';

export const SupportWidgetContext = createContext<SupportWidgetConfig | null>(null);

export function useWidgetConfig(): SupportWidgetConfig {
  const ctx = useContext(SupportWidgetContext);
  if (!ctx) {
    throw new Error(
      '[@netrun/support-widget] useWidgetConfig must be used inside <SupportWidget>',
    );
  }
  return ctx;
}
